
  import { Vue, Component, Prop } from "vue-property-decorator";

  import AllDocumentsSearchableList from "@/components/documents/AllDocumentsSearchableList.vue";

  import { User, Company } from "@/generated/graphql";

  @Component({
    components: {
      AllDocumentsSearchableList,
    },
  })
  export default class DocumentsManagerAll extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;


    get query() {
      return {
       "company_id": { "_eq": this.company.id },
      };
    }
  }
